import { SpecimenResource } from "@skinsoft/types";
import { dbCacheUp } from "../dexie/cache-up";
import { OfflineDataUpdateCacher } from "..";

// @ts-ignore
export class SpecimenOfflineDataUpdateCacher extends OfflineDataUpdateCacher<SpecimenResource> {
    constructor() {
        super(dbCacheUp.specimen)
    }
}